import { FcGoogle } from "react-icons/fc";

export const GoogleButton = ({ label = "Continue with Google" }) => {
  const onClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      <div className="my-5 flex items-center gap-3">
        <div className="h-px flex-1 bg-slate-200" />
        <span className="text-xs text-slate-400 uppercase tracking-widest">or</span>
        <div className="h-px flex-1 bg-slate-200" />
      </div>
      <button type="button" onClick={onClick} data-testid="google-login-btn"
        className="w-full inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-full border-2 border-slate-200 bg-white text-brand-navy font-semibold hover:border-slate-300 hover:bg-slate-50 transition-colors">
        <FcGoogle className="w-5 h-5" /> {label}
      </button>
    </>
  );
};
